import { render, staticRenderFns } from "./TablePending.vue?vue&type=template&id=ba52880a"
import script from "./TablePending.vue?vue&type=script&lang=js"
export * from "./TablePending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports